export const status = [
    {
        label:'全部',
        value:0
    },
    {
        label:'待支付',
        value:1
    },
    {
        label:'已取消',
        value:2
    },{
        label:'已支付',
        value:4
    },
    {
        label:'申请退款',
        value:5
    },
    {
        label:'进行中',
        value:9
    },
    {
        label:'已完成',
        value:10
    },
    {
        label:'已发货',
        value:11
    },
    {
        label:'已退款',
        value: 8
    }
]